export default __webpack_public_path__ + "static/media/homeHero.ea5d66e8.png";